var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fee-calc-global"},[_c('Banner'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('keep-alive',[_c('router-view')],1)],1),_vm._v(" "),_c('PageFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }